import { StylesContext } from "@material-ui/styles"
import styled from "styled-components"
import React from "react"

const Container = styled("div")`
width: 100vw;
height: 150 px;
background-color: cyan;
margin: 25px; 
justify-content: center;

padding: 10 px 0;
display: flex;
flex-direction: column;
align-items: center;
`

const ListItem = styled("li")`
    margin: 10px;  
`
 
const FAQ2 = () => {
    return (
        <Container>

        <h2>WHAT IS YOUR SUPPLY AND PRICE?</h2>

        <ul style={{padding: '0px 25%'}}>

        There will be 333 Buff Muscles in our genesis collection, priced at 0.5 SOL. 

        </ul>

        </Container>

    )
}

export default FAQ2;